import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services';
import Modal from '../../helpers/Modal';
export const NewNoteForm = ({ project, onNoteCreated }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [noteBody, setNoteBody] = useState('');

    const closeModal = () => {
        setIsModalOpen(false);
        setIsSubmitting(false);
        setNoteBody('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmedNote = noteBody.trim();
        if (!trimmedNote || isSubmitting) return;

        setIsSubmitting(true);
        try {
            const payload = { note_body: trimmedNote };
            const response = await postData(token, `${base_url}/apis/projects/create-note/${project.id}`, payload);

            if (response && response.status && response.status >= 400) {
                throw response;
            }

            if (typeof onNoteCreated === 'function') {
                onNoteCreated(response, trimmedNote);
            }

            if (typeof window.showAlert === 'function') {
                window.showAlert(200, response?.msg || 'Note created successfully!');
            }

            closeModal();
        } catch (error) {
            console.error('Error creating note:', error);
            const status = error?.status || 500;
            const message = error?.msg || 'Failed to create note. Please try again.';
            if (typeof window.showAlert === 'function') {
                window.showAlert(status, message);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const noteForm = (
        <div>
            <h2 className="modal-title">Create Note</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="note_body" className="form-label">
                        Note Body *
                    </label>
                    <textarea
                        id="note_body"
                        name="note_body"
                        className="form-textarea"
                        rows="6"
                        value={noteBody}
                        onChange={(e) => setNoteBody(e.target.value)}
                        placeholder="Write your project note..."
                        required
                    />
                </div>
                <div className="form-actions">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeModal}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting || !noteBody.trim()}
                    >
                        {isSubmitting ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin /> Creating...
                            </>
                        ) : (
                            'Create Note'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <div>
            <button className="btn btn-action btn-primary" onClick={() => setIsModalOpen(true)}>
                <FontAwesomeIcon icon={faPlus} /> New Note
            </button>
            {isModalOpen && <Modal form={noteForm} setIsModalOpen={closeModal} />}
        </div>
    );
};
